export default __webpack_public_path__ + "static/media/Broken.3e28014f.svg";